import { Component, OnInit, HostBinding, Input } from "@angular/core";
import { SidebarMenuService } from "./sidebar-menu.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SidenavMenu } from "./sidebar-menu.model";
import { Router } from "@angular/router";
import { expand } from "rxjs/operators";
import { EnumService } from "../services/enum.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  animations: [
    trigger("indicatorRotate", [
      state("collapsed", style({ transform: "rotate(0deg)" })),
      state("expanded", style({ transform: "rotate(180deg)" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4,0.0,0.2,1)")
      ),
    ]),
  ],
})
export class SidebarComponent implements OnInit {
  expanded: boolean = false;
  @HostBinding("attr.aria-expanded") ariaExpanded = this.expanded;
  @Input() item: SidenavMenu;
  @Input() depth: number;

  constructor(
    private sidenavMenuService: SidebarMenuService,
    public router: Router,
    private enumService: EnumService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    // console.log(this.item)
    this.sidenavMenuService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        // //console.log(`Checking '/${this.item.route}' against '${url}'`);
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
        // //console.log(`${this.item.route} is expanded: ${this.expanded}`);
      }
    });
  }
  onItemSelected(item: SidenavMenu) {
    if(sessionStorage.getItem("paramFilter") != null){
      let paramNomItem =  {
        param1: "",
        param2: "",
        param3: ""
      }
     sessionStorage.setItem("paramFilter",JSON.stringify(paramNomItem)) 
    }
    sessionStorage.setItem("marca","TODAS")
    if(item.route == '/pages/contact'){
      this.router.navigate([item.route]);
      document.getElementById('buttonSideBar').click()
    }else if(item.route == '/pages/shop'){
      document.getElementById('buttonSideBar').click()
      this.router.navigate(["/home/products", 0, 0, 0, "TODAS", 0, 0, 1], {
        queryParams: { Tienda: 0 },
      });
    }
     else{
      if (!item.children || !item.children.length) {
        document.getElementById('buttonSideBar').click()
        this.router.navigate([item.route]);
        this.enumService.setTitleMeta(item.displayName + " | Novaplaza", {
          name: "description",
          content:
            "Ofrecemos las mejores " +
            item.displayName +
            " al mejor precio en Arequipa",
        });
      }
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }
}
